/* global rp$, window */
'use strict';

var THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');
	const myGarage = require('public/js/api/garage-session')({window});
	const  { fetchGarage } = require('public/js/api/garage');
	const componentWrapperClass = '.garage-component';

	function HandleRemoveClick() {
		myGarage.removeAll();
	}

	function loadGarageFromStorage() {
		myGarage.get().then(function (garageSessionData) {
			fetchGarage({
				data: {
					vehicles: garageSessionData,
					withHtml: true,
				},
			}).then((data) => {
				if (data.recent_cars) {
					const garageData = data.recent_cars.map((car) => ({
						rp_car_id: car.rp_car_id,
						vin: car.vin,
					}));

					myGarage.set(garageData);
				}

				if (data.html) {
					addVehicleFlyoutLinks(data.html);
				}
			});
		});
	}

	function addVehicleFlyoutLinks(listHtml) {
		const $flyOutListWrapper = rp$('.garage.flyout .recent-cars ul', componentWrapperClass);
		$flyOutListWrapper.html('').html(listHtml);
	}

	(function GarageListModule() {
		$onReady({
			rp$,
			window,
			label: 'garage_component',
			fn: function() {
				loadGarageFromStorage();
				rp$(componentWrapperClass).on('click', '.clear-all-vehicles', HandleRemoveClick);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
